// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trend-legend tr td {
    white-space: nowrap;
    text-align: center;
    border: 1px solid rgba(0,0,0,.5);
    padding: 0;
    margin: 0;
}

.trend-legend tr:last-child td {
    border-bottom: none;
}

.color-group {
    width: 5px;
}

.trend-legend {
    height: 100%;
    width: 100%;
    background: #fff;
}

#group-list-wrap tr.active {
    background-color: #cbe4fa80;
}
#trend-legend-body tr.active {
    background-color: #cbe4fa80;
}

.trend-legend thead tr {
    position: sticky;
    top: 0;
    z-index: 1;
    border: 1px solid;
}

.trend-legend {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    font-size: 12px;
}

.group-color-picker {
    position: relative;
}

.color-group,
.group-pen-visible {
    cursor: pointer;
}

.color-group,
.group-pen-visible {
    opacity: .5;
}

    .color-group.active,
    .group-pen-visible.active {
        opacity: 1;
        background: #D0D0D0;
    }

.group-pen-value {
    font-size: 12px;
}

.group-label-wrap .group-color {
    height: 27px;
    width: 5px;
}

.groups-wrapper {
    padding: 0;
    margin: 0;
}

    .groups-wrapper li {
        list-style: none;
    }

.group-pen-visible {
    width: 32px;
}

.groups-wrapper thead tr {
    border: none;
}

.groups-wrapper .group-pen-name {
    border-right: none;
    text-align: left;
    padding-left: 10px;
}

.groups-wrapper .group-pen-arrow {
    border-left: none;
    text-align: right;
    padding-right: 10px;
}

.group-label-wrap .tr {
    cursor: pointer;
}

.group-label-wrap .group-pen-arrow,
.group-label-wrap .group-pen-name {
    cursor: pointer;
}

.groups-wrapper .trend-legend .group-pen-arrow svg {
    transform: rotate(-90deg);
}

.groups-wrapper .trend-legend.active .group-pen-arrow svg {
    transform: rotate(0);
}

.groups-wrapper .trend-legend.active tbody {
    display: table-row-group;
}

.groups-wrapper .trend-legend tbody {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/controls/trend/legend/legend.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,WAAW;AACf;;IAEI;;QAEI,UAAU;QACV,mBAAmB;IACvB;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;IAEI;QACI,gBAAgB;IACpB;;AAEJ;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".trend-legend tr td {\r\n    white-space: nowrap;\r\n    text-align: center;\r\n    border: 1px solid rgba(0,0,0,.5);\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.trend-legend tr:last-child td {\r\n    border-bottom: none;\r\n}\r\n\r\n.color-group {\r\n    width: 5px;\r\n}\r\n\r\n.trend-legend {\r\n    height: 100%;\r\n    width: 100%;\r\n    background: #fff;\r\n}\r\n\r\n#group-list-wrap tr.active {\r\n    background-color: #cbe4fa80;\r\n}\r\n#trend-legend-body tr.active {\r\n    background-color: #cbe4fa80;\r\n}\r\n\r\n.trend-legend thead tr {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1;\r\n    border: 1px solid;\r\n}\r\n\r\n.trend-legend {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: center;\r\n    font-size: 12px;\r\n}\r\n\r\n.group-color-picker {\r\n    position: relative;\r\n}\r\n\r\n.color-group,\r\n.group-pen-visible {\r\n    cursor: pointer;\r\n}\r\n\r\n.color-group,\r\n.group-pen-visible {\r\n    opacity: .5;\r\n}\r\n\r\n    .color-group.active,\r\n    .group-pen-visible.active {\r\n        opacity: 1;\r\n        background: #D0D0D0;\r\n    }\r\n\r\n.group-pen-value {\r\n    font-size: 12px;\r\n}\r\n\r\n.group-label-wrap .group-color {\r\n    height: 27px;\r\n    width: 5px;\r\n}\r\n\r\n.groups-wrapper {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n    .groups-wrapper li {\r\n        list-style: none;\r\n    }\r\n\r\n.group-pen-visible {\r\n    width: 32px;\r\n}\r\n\r\n.groups-wrapper thead tr {\r\n    border: none;\r\n}\r\n\r\n.groups-wrapper .group-pen-name {\r\n    border-right: none;\r\n    text-align: left;\r\n    padding-left: 10px;\r\n}\r\n\r\n.groups-wrapper .group-pen-arrow {\r\n    border-left: none;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n}\r\n\r\n.group-label-wrap .tr {\r\n    cursor: pointer;\r\n}\r\n\r\n.group-label-wrap .group-pen-arrow,\r\n.group-label-wrap .group-pen-name {\r\n    cursor: pointer;\r\n}\r\n\r\n.groups-wrapper .trend-legend .group-pen-arrow svg {\r\n    transform: rotate(-90deg);\r\n}\r\n\r\n.groups-wrapper .trend-legend.active .group-pen-arrow svg {\r\n    transform: rotate(0);\r\n}\r\n\r\n.groups-wrapper .trend-legend.active tbody {\r\n    display: table-row-group;\r\n}\r\n\r\n.groups-wrapper .trend-legend tbody {\r\n    display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
